'use es6';

import { createSelector } from 'reselect';
import get from 'transmute/get';
import { STARTED, SUCCEEDED, FAILED, UNINITIALIZED } from 'MeetingsBase/constants/RequestStatusTypes';

var getRequestStatuses = function getRequestStatuses(state) {
  return state.requestStatus;
};

export function getRequestStatus(requestType) {
  return createSelector([getRequestStatuses], function (requestStatuses) {
    return requestStatuses.get(requestType) || UNINITIALIZED;
  });
}
var getBookInfo = get('bookInfo');
export var getMeetingsCreateStatus = getRequestStatus('MEETING_CREATE');
export var getMeetingsCancelStatus = getRequestStatus('MEETING_CANCEL');
export var getMeetingRescheduleStatus = getRequestStatus('MEETING_RESCHEDULE');
export var getPublicAvailabilityInfoFetchStatus = getRequestStatus('PUBLIC_AVAILABILITY_INFO_FETCH');
export var getPublicAvailabilityOwnerFetchStatus = getRequestStatus('PUBLIC_AVAILABILITY_INFO_OWNER_FETCH');
var getMeetingsUserFetchStatus = getRequestStatus('MEETINGS_USER_FETCH');
export var getPublicGlobalBrandingFetchStatus = getRequestStatus('PUBLIC_GLOBAL_BRANDING_FETCH');
export var getCompanyNameFetchStatus = getRequestStatus('COMPANY_NAME_FETCH');
export var meetingCreationSuccess = createSelector([getMeetingsCreateStatus], function (meetingsCreateStatus) {
  return meetingsCreateStatus === SUCCEEDED;
});
export var meetingRescheduleSuccess = createSelector([getMeetingRescheduleStatus], function (meetingRescheduleStatus) {
  return meetingRescheduleStatus === SUCCEEDED;
});
export var meetingRescheduleFailed = createSelector([getMeetingRescheduleStatus], function (meetingRescheduleStatus) {
  return meetingRescheduleStatus === FAILED;
});
export var meetingCreationFailed = createSelector([getMeetingsCreateStatus, getMeetingRescheduleStatus], function (meetingsCreateStatus, meetingRescheduleStatus) {
  return meetingsCreateStatus === FAILED || meetingRescheduleStatus === FAILED;
});
export var availabilityFetchFailed = createSelector([getPublicAvailabilityInfoFetchStatus], function (publicAvailabilityInfoFetchStatus) {
  return publicAvailabilityInfoFetchStatus === FAILED;
});
export var availabilityFetchSuccess = createSelector([getPublicAvailabilityInfoFetchStatus], function (publicAvailabilityInfoFetchStatus) {
  return publicAvailabilityInfoFetchStatus === SUCCEEDED;
});
export var getIsFetchingPublicAvailability = createSelector([getPublicAvailabilityInfoFetchStatus], function (publicAvailabilityInfoFetchStatus) {
  return publicAvailabilityInfoFetchStatus === UNINITIALIZED || publicAvailabilityInfoFetchStatus === STARTED;
});
export var getIsFetchingOwnerPublicAvailability = createSelector([getPublicAvailabilityOwnerFetchStatus], function (publicAvailabilityOwnerFetchStatus) {
  return publicAvailabilityOwnerFetchStatus === UNINITIALIZED || publicAvailabilityOwnerFetchStatus === STARTED;
});
export var meetingsUserFetchStarted = createSelector([getMeetingsUserFetchStatus], function (meetingsUserFetchStatus) {
  return meetingsUserFetchStatus === STARTED;
});
export var meetingsUserFetchFailed = createSelector([getMeetingsUserFetchStatus], function (meetingsUserFetchStatus) {
  return meetingsUserFetchStatus === FAILED;
});
export var meetingsUserFetchSuccess = createSelector([getMeetingsUserFetchStatus], function (meetingsUserFetchStatus) {
  return meetingsUserFetchStatus === SUCCEEDED;
});
export var getIsFetchingCompanyName = createSelector([getCompanyNameFetchStatus], function (companyNameFetchStatus) {
  return companyNameFetchStatus === UNINITIALIZED || companyNameFetchStatus === STARTED;
});
export var bookingPageLoading = getIsFetchingPublicAvailability;
export var shouldRenderBookingPage = createSelector([bookingPageLoading, getMeetingsCreateStatus, getMeetingRescheduleStatus], function (isBookingPageLoading, meetingsCreateStatus, meetingRescheduleStatus) {
  var meetingNotCreatedYet = meetingsCreateStatus === UNINITIALIZED || meetingsCreateStatus === STARTED;
  var meetingNotRescheduledYet = meetingRescheduleStatus === UNINITIALIZED || meetingRescheduleStatus === STARTED;
  return !isBookingPageLoading && meetingNotCreatedYet && meetingNotRescheduledYet;
});
export var isSubmittingMeeting = createSelector([getMeetingsCreateStatus, getMeetingRescheduleStatus], function (meetingsCreateStatus, meetingRescheduleStatus) {
  return meetingsCreateStatus === STARTED || meetingRescheduleStatus === STARTED;
});
export var fetchBookInfoFailed = createSelector([getPublicAvailabilityInfoFetchStatus, getBookInfo], function (publicAvailabilityInfoFetchStatus, _ref) {
  var availableTimePeriods = _ref.availableTimePeriods;
  return publicAvailabilityInfoFetchStatus === FAILED || !availableTimePeriods;
});